import React from 'react'

const SubFooter = () => {
  return (
    <div style={{
        backgroundColor: '#E72929',
        color: '#fff',
        paddingBottom: '10px',
        paddingTop: '10px',
        fontFamily: 'Poppins',
        textAlign: 'center',
        width: '100%',
        height: '40px',
    }}>
      <p style={{fontSize:'12px'}}>© 2025 RedAlert. All rights reserved. Version 1.0.0</p>
    </div>
  )
}

export default SubFooter
